<template>
    <b-modal id="workPlanModal" 
        :title="$t('project.workPlanTitle')" 
        hide-footer size="huge" 
        @hidden="clearForm();sysChange()" @shown="workPlans()">

        <b-tabs content-class="mt-3">
            <b-tab :title="$t('workPlan.mainPlan')" lazy>
                <b-form v-on:submit.prevent="createWorkPlan">
                    <b-form-row class="mb-3">
                        <b-col lg="12">
                            <h4>
                                {{ $t('hForm.mainPlan') }}
                            </h4>
                        </b-col>
                        <b-col sm="auto" lg="6">
                            <label for="dateUsed">{{ $t('hForm.dateUsed') }}</label>
                            <input type="date" required id="dateUsed" 
                                class="form-control" 
                                v-model="hForm.dateUsed">
                        </b-col>
                        <b-col sm="auto" lg="6">
                            <label for="budgetUsed">{{ $t('hForm.budgetUsed') }}</label>
                            <input type="number" required id="budgetUsed" 
                                class="form-control" 
                                v-model.number="hForm.budgetUsed">
                        </b-col>
                    </b-form-row>
                
                    <b-form-row>
                        <b-col lg="12">
                            <b-row class="pt-2">
                                <b-col lg="6">
                                    <b-button size="sm" block variant="primary" @click="closeModal()" class="mr-2" >{{$t("hForm.back")}}</b-button>
                                </b-col>
                                <b-col lg="6">
                                    <b-button size="sm" block variant="success" type="submit" >{{$t("hForm.addHistory")}}</b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-form-row>
                </b-form>



                <!-- <div class="w-100">
                    <b-table striped hover :items="notes" 
                        :fields="fields">

                        <template v-slot:cell(actions)="data">
                            <b-button size="sm" variant="danger" 
                            @click="deleteHistory(data.item.id)">{{$t("hForm.delete")}}</b-button>
                        </template>

                    </b-table>
                </div> -->
            </b-tab>
            <b-tab title="Lazy tab" lazy>
                <b-alert show>I'm lazy mounted!</b-alert>
            </b-tab>
        </b-tabs>



        
    </b-modal>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader} from "@/config/config";
    import vue from 'vue';
    export default {
        name:"WorkPlanModal",
        props:["pId"],
        data(){
            return {
                hForm:{
                    dateUsed:"",
                    budgetUsed:0,
                    datePlanned:"",
                    budgetPlanned:0,
                    currentUsed:0,
                    budgetLack:0,
                    warning:"",
                    pId:0
                },
                years:[],
                months:[],
                notes:[],
                fields:[
                    {
                        key:"dateUsed",
                        label: 'hForm.dateUsed',
                    },

                    {
                        key: 'budgetUsed',
                        label: 'hForm.budgetUsed',
                    },
                    {
                        key: 'datePlanned',
                        label: 'hForm.datePlanned',
                    },
                    {
                        key:"budgetPlanned",
                        label: 'hForm.budgetPlanned',
                    },
                    {
                        key:"currentUsed",
                        label: 'hForm.currentUsed',
                    },
                    {
                        key:"budgetLack",
                        label: 'hForm.budgetLack',
                    },
                    {
                        key:"warning",
                        label: 'hForm.warning',
                    },
                ]
            }
        },
        methods:{
            createNote(){
                alert("me is called i will do my job");
                if(this.pId==0){
                    alert("Project  not set");
                    return;
                }
                this.hForm.pId=this.pId;
                axios.post(apiDomain+"/p/budget/create",this.hForm,{headers:getHeader()})
                .then(response=>{
                    this.clearForm();
                    this.listBudgetNotes();
                    
                }).catch(error=>{
                    console.log(error);
                });
            },
            listBudgetNotes(){
                axios.post(apiDomain+"/p/budget/list",{pId:this.pId},{headers:getHeader()})
                .then(response=>{
                    //alert(JSON.stringify(this.notes));
                    this.notes=response.data;
                }).catch(error=>{
                    console.log(error);
                });
            },
            createHistory(){
                alert(JSON.stringify(this.hForm));
            },
            closeModal(){
                this.clearForm();
                this.$bvModal.hide("historyModal");

            },
            setDates(){
                let currentYear=new Date().getFullYear();
                for(let year = 2000;year<=currentYear;year++){
                    this.years.push(year);
                }
                for(let month=1;month<=12;month++){
                    this.months.push(month);
                }
            },
            clearForm(){
                this.hForm={
                    dateUsed:"",
                    budgetUsed:0,
                    datePlanned:"",
                    budgetPlanned:0,
                    currentUsed:0,
                    budgetLack:0,
                    warning:"",
                    pId:0
                };
            },
            sysChange(){}
        },
        created(){
            this.setDates();
            //this.listBudgetNotes()
        }
    }
</script>